module.exports = __webpack_public_path__ + "img/tip-empty-step.45e875bd.png";